var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(this.model).length !== 0)?_c('div',[(this.type == 'customer_representative'
                      || this.type == 'customer-address-update'
                      || this.type == 'mail-forward-address-creation'
                      || this.type == 'mail-forward-address-update'
                      || this.type == 'representative-address-update'
                      || this.type == 'customer-address-creation'
                      )?_c('model-adress',{attrs:{"model":this.model}}):(this.type == 'representative'
                        || this.type == 'representative-creation'
                        || this.type == 'representative-update'
                        || this.type == 'representative-person-update'
                        || this.type == 'representative-termination'
                        || this.type == 'representative-mainification'
                        || this.type == 'representative-unmainification'
                        )?_c('model-representative',{attrs:{"model":this.model}}):(this.type == 'domiciliation-contract-validation'
                                                      || this.type == 'office-contract-validation')?_c('model-domiciliation-contract-validation',{attrs:{"model":this.model}}):(this.type == 'contract-option-creation' || this.type == 'contract-option-termination')?_c('model-option-creation',{attrs:{"model":this.model}}):_c('model-customer',{attrs:{"model":this.model}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-686450c6","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Demands/NewModel.vue
// module id = 1916
// module chunks = 0